const { READ_ONLY_FEATURES } = process.env;

const crudConfig = {
    endpoint: 'criterias',
    primaryKey: 'criteriaId',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'cds',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: true,
            args: ['criteriaId'],
            query: {
                expand: ['CriteriaPredicateDTO', 'CriteriaPredicatePartDTO']
            }
        },
        fetchOneForExport: {
            method: 'get',
            returnType: 'Object',
            service: 'cds',
            firstArgSlug: true,
            args: ['criteriaId'],
            query: {
                expand: [
                    'CriteriaPredicateDTO',
                    'CriteriaPredicatePartDTO',
                    'CriteriaVersionRelDTO',
                    'CriteriaPredicatePartConceptDTO',
                    'CriteriaPredicatePartRelDTO'
                ]
            }
        },
        duplicateCriteria: {
            method: 'put',
            returnType: 'Object',
            service: 'cds',
            args: ['criteriaId'],
            query: {
                property: 'customSave=true,queryClass=CloneCriteria'
            }
        }
    },
    metadata: {
        endpoint: 'cds/criterias',
        functions: {
            fetch: {
                method: 'get',
                returnType: 'Object',
                service: 'cds',
                args: [],
                query: {}
            }
        }
    }
};

if (!READ_ONLY_FEATURES || READ_ONLY_FEATURES === 'false') {
    crudConfig.functions = {
        ...crudConfig.functions,
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'cds'
            // args: ['nodeId', 'nodeDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'cds'
            // args: ['nodeId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'cds'
            // args: ['nodeDoc']
        },
        import: {
            method: 'post',
            returnType: 'Object',
            service: 'cds',
            // args: ['import'],
            // firstArgSlug: true,
            query: {
                property: 'queryClass=ImportCriteria,customSave=true'
            }
        }
    };
}

export default crudConfig;
